import swal from 'sweetalert';
import swal2 from 'sweetalert2';
import './swal/swal.css';

const Toast = swal2.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', swal2.stopTimer);
        toast.addEventListener('mouseleave', swal2.resumeTimer);
    }
});

export default {
    error: (text, showIcon = true) => swal(text, {icon: showIcon ? 'error' : '', buttons: [false, '确定']}),
    succ: text => swal(text, {icon: 'success', buttons: [false, '确定']}),
    swal: (...args) => swal(...args),
    alert: (title, text, options) => swal2.fire({
        title: title || '提示',
        text: text || '',
        confirmButtonText: '我知道了',
        confirmButtonColor: 'hsla(92, 38%, 46%, 1)',
        scrollbarPadding: false,
        ...options
    }),
    toast: (title, timer) => Toast.fire({
        title: title || '',
        timer: timer || 3000,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', swal2.stopTimer);
            toast.addEventListener('mouseleave', swal2.resumeTimer);
            toast.addEventListener('click', () => swal2.close());
        }
    }),
    noAccess () {
        this.error('您无此操作权限，请咨询小猴编程老师！');
    },
    swalAgent (
        err,
        defaultText,
        options
    ) {
        if (
            typeof err === 'object' &&
            err.status === 401
        ) return;
        const {
            data = {}, message, statusText, status
        } = err;
        const msg = message || data.message || (status + ': ' + statusText);
        let msgs = defaultText ? defaultText : '';
        if (msg) msgs += ' 错误信息：' + msg;
        return swal(
            msgs,
            {icon: 'error', buttons: [false, '确定'], ...options}
        );
    }
};
